import { connect } from 'react-redux';
import MsTeamsSettings from './MsTeamsSettings';
import { toggleSnackBar, toggleModal } from 'state/callers';
import { patchAccount } from 'state/callers/account';
import { selectTeamId } from 'state/actions';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import { getMsTeamsSensorAuthorizationSelector } from 'state/selectors/sensors-authorizations';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import { individualContributorsSelector } from 'state/selectors/contributors';
import { myAccountSelector } from 'state/selectors/account';

const mapStateToProps = state => {
  const { currentTeams } = state;
  const { uiState } = state;
  return {
    msTeamsSensorAuthorization: getMsTeamsSensorAuthorizationSelector(state),
    team: selectedTeamSelector(state),
    uiState,
    account: myAccountSelector(state),
    currentTeams,
    contributors: individualContributorsSelector(state)
  };
};

const mapDispatchToProps = {
  toggleSnackBar,
  toggleModal,
  patchAccount,
  selectTeamId
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(MsTeamsSettings, 'Microsoft Teams Settings'));
